/**
 * @module events/types/transitionEnd
 */

/**
 * @type {string}
 */
export default 'transitionend'
